export default "__VITE_ASSET__DqiIF01J__"